document.addEventListener('DOMContentLoaded', function () {
    const observer = new MutationObserver(function () {
        const postcodeField = document.querySelector('.cf-field-container.postcode input');
        const prefectureField = document.querySelector('.cf-field-container.prefecture select');
        const cityField = document.querySelector('.cf-field-container.city input');
        const townField = document.querySelector('.cf-field-container.town input');

        if (postcodeField && prefectureField && cityField && townField) {
            observer.disconnect(); // 監視を停止

            // 日本語→英語の都道府県マッピング
            const prefectureMapping = {
                "北海道": "Hokkaido",
                "青森県": "Aomori",
                "岩手県": "Iwate",
                "宮城県": "Miyagi",
                "秋田県": "Akita",
                "山形県": "Yamagata",
                "福島県": "Fukushima",
                "茨城県": "Ibaraki",
                "栃木県": "Tochigi",
                "群馬県": "Gunma",
                "埼玉県": "Saitama",
                "千葉県": "Chiba",
                "東京都": "Tokyo",
                "神奈川県": "Kanagawa",
                "新潟県": "Niigata",
                "富山県": "Toyama",
                "石川県": "Ishikawa",
                "福井県": "Fukui",
                "山梨県": "Yamanashi",
                "長野県": "Nagano",
                "岐阜県": "Gifu",
                "静岡県": "Shizuoka",
                "愛知県": "Aichi",
                "三重県": "Mie",
                "滋賀県": "Shiga",
                "京都府": "Kyoto",
                "大阪府": "Osaka",
                "兵庫県": "Hyogo",
                "奈良県": "Nara",
                "和歌山県": "Wakayama",
                "鳥取県": "Tottori",
                "島根県": "Shimane",
                "岡山県": "Okayama",
                "広島県": "Hiroshima",
                "山口県": "Yamaguchi",
                "徳島県": "Tokushima",
                "香川県": "Kagawa",
                "愛媛県": "Ehime",
                "高知県": "Kochi",
                "福岡県": "Fukuoka",
                "佐賀県": "Saga",
                "長崎県": "Nagasaki",
                "熊本県": "Kumamoto",
                "大分県": "Oita",
                "宮崎県": "Miyazaki",
                "鹿児島県": "Kagoshima",
                "沖縄県": "Okinawa"
            };

            // 郵便番号フィールドのリアルタイム入力対応
            postcodeField.addEventListener('input', async function () {
                const postcode = postcodeField.value.replace(/[^0-9]/g, ''); // 数字以外を除去

                // 入力が7桁になった時点でAPI呼び出し
                if (postcode.length === 7) {
                    try {
                        // ZipCloud APIを呼び出し
                        const response = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postcode}`);
                        const data = await response.json();

                        if (data.results) {
                            const result = data.results[0];
                            const prefectureJP = result.address1; // 日本語の都道府県名
                            const prefectureEN = prefectureMapping[prefectureJP]; // 英語に変換

                            if (prefectureEN) {
                                prefectureField.value = prefectureEN; // 都道府県の英語名を選択
                            }
                            // 市区町村と町域の値を設定
                            setTimeout(() => {
                                setFieldValue(cityField, result.address2 || '');
                                setFieldValue(townField, result.address3 || '');
                            }, 100);
                        } else {
                            // 該当なしの場合はフィールドをクリア
                        }
                    } catch (error) {
                        console.error('APIエラー:', error);
                    }
                }
            });
        }
    });

    // 監視対象の親要素を指定
    const targetNode = document.body;
    const config = { childList: true, subtree: true };
    observer.observe(targetNode, config);
});
function setFieldValue(field, value) {
    Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')
        .set.call(field, value); // 直接DOMプロパティを操作

    // イベントを発火してライブラリ側に通知
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
}